import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/LOGIN_SUCCESS': {
        const { user } = action.payload;
        draft.profile = user;
        break;
      }
      case '@auth/LOGOUT_APP': {
        draft.profile = null;
        break;
      }
      case '@user/UPDATE_USER_SUCCESS': {
        const { user } = action.payload;
        draft.profile = user;
        break;
      }

      case '@user/CHAT_AUTENTICADO': {
        state.profile.autenticado = !state.profile.autenticado;
        draft.profile = state.profile;
        break;
      }
      case '@user/CHAT_DESLOGAR': {
        draft.profile = state.profile;
        break;
      }
      default:
    }
  });
}
